import { Button } from "../../../design/button";
import { DialogActions, DialogBody, DialogTitle } from "../../../design/dialog";
import { Table, TableBody, TableRow, TableCell } from "../../../design/table";
import { Text } from "../../../design/text";
import { FinancialItem } from "../../../models/FinancialItem";
import { financialItemTypes } from "../../../models/FinancialItemType";

interface Props {
  setType: (type: FinancialItem["type"]) => void;
  onClose?: () => void;
}

const ChooseFinancialItemTypeStep: React.FC<Props> = ({ setType, onClose }) => {
  return (
    <>
      <DialogTitle>Choose Property Type</DialogTitle>
      <DialogBody>
        <Table>
          <TableBody>
            {financialItemTypes.map((holiday) => (
              <TableRow key={holiday.id} onClick={() => setType(holiday.id)}>
                <TableCell className="font-medium">
                  {holiday.title}
                  {holiday.description && (
                    <Text className="text-sm">{holiday.description}</Text>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Back
        </Button>
      </DialogActions>
    </>
  );
};

export default ChooseFinancialItemTypeStep;
